module.exports = __webpack_public_path__ + "static/media/404-img.19f9dcac.png";